export default {
  data () {
    return {
      services: [],
      id_eligibilite: null
    }
  },
  mounted() {
    var sessionSouscription = this.$globalService.getSessionSouscription();
    if(sessionSouscription != null && sessionSouscription.eligibilite && sessionSouscription.eligibilite.service){
      this.$root.progress = false;
      this.services = sessionSouscription.eligibilite.service;
      this.id_eligibilite = sessionSouscription.eligibilite.id_eligibilite.substr(0,4) +' '+ sessionSouscription.eligibilite.id_eligibilite.substr(4,4) +' '+ sessionSouscription.eligibilite.id_eligibilite.substr(8,4) +' '+ sessionSouscription.eligibilite.id_eligibilite.substr(12,2);
    }else{
      this.$dialog.error({
        text: "Une erreur s'est produite",
        title: 'Erreur',
        persistent: false,
        actions: {
          false: 'Fermer'
        }
      })
    }

  }
}